/*global google*/

import React from "react";
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
/*
    Importing React Scroll for animating scrolling down to elements
*/
import { animateScroll as scroll } from 'react-scroll';
/*
    Importing StateSelector for autocomplete States input box
*/
import StateSelector2 from "../../partials/StateSelector2";
/*
    Importing LoanSlider that is a component that loanamt in Redux
*/
import LoanSlider from "../../partials/LoanSlider";
/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextInfoButton from "../../partials/NextInfoButton";
/*
    This page is using a template VerifyLayout
    TODO: May change this to one StepLayout
*/
import AccountLayout from '../../../containers/AccountLayout';
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setStep, setInfo, setLatest, setCurrent } from "../../../store/actions/FormAction";
/*
    AddressInfo view that displays the Address Info page
    Using Google Place Autocomplete and scriptLoader decorator
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
import './address.css';

/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();

const statesserved = [
  "AL",
  "CA",
  "DE",
  "IL",
  "KS",
  "MD",
  "MS",
  "MO",
  "NM",
  "OH",
  "SD",
  "TN",
  "TX",
  "UT",
  "WI"
];

class AddressInfo extends React.Component {

  constructor(props){
    super(props);

    this.tempst = this.props.st;
    this.tempstt = this.props.stt;

    this.handleStreetChange = this.handleStreetChange.bind(this);
    this.handleUnitChange = this.handleUnitChange.bind(this);
    this.handleCityChange = this.handleCityChange.bind(this);
    this.handleZipChange = this.handleZipChange.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleStateConfirm = this.handleStateConfirm.bind(this);
  }

  componentDidMount() {
    this.props.updateForm("pagename", "Address Information");
    this.props.lateststep < 3 && this.props.setLatest(3);
    this.props.setCurrent(3);
    this.props.setStep(1);
    this.props.setInfo(1);

    if (this.props.address.length < 1){
      setTimeout(()=>{document.getElementById('addressinput').focus()}, 10);
    } else if (this.props.alladdresschecked){
      document.getElementById("selectedAddress").classList.remove("hidden");
      if (this.props.street.length > 0){
        document.getElementById("street").classList.add('filled');
        document.querySelector("label[for='street']").classList.add('activeaddy');
      }
      if (this.props.city.length > 0){
        document.getElementById("city").classList.add('filled');
        document.querySelector("label[for='city']").classList.add('activeaddy');
      }
      if (this.props.st.length > 0){
        document.getElementById("state-placeholder").classList.add('state-label');
        document.querySelector("label[for='st']").classList.add('active');
      }
      if (this.props.zip.length > 0){
        document.getElementById("zip").classList.add('filled');
        document.querySelector("label[for='zip']").classList.add('activeaddy');
      }
    }

    //TODO: I don't see my addressinfo

  }

  handleStreetChange(e) {
    let street = e.target.value;
    this.props.updateForm("street", street);

    let newaddress = street+", "+this.props.city+", "+this.props.stt+", "+this.props.zip;
    this.props.updateForm("address", newaddress);

    let streettip = document.getElementById("streettip");

    // let streetnumchecked = true;
    // this.props.updateForm("streetnumberchecked", true);
    let stelements = street.split(' ');
    let streetnumchecked = false;
    if ( stelements.length >= 3 && validation.hasNumber(stelements[0]) ){
      streettip.classList.add("hidden");
      streettip.innerHTML = "";
      this.props.updateForm("streetnumberchecked", true);
      streetnumchecked = true;
      document.querySelector("label[for='unit']").classList.remove("hidden");
    } else if ( stelements.length === 2 && validation.hasNumber(stelements[0]) ){
      streettip.classList.add("hidden");
      streettip.innerHTML = "";
      this.props.updateForm("streetnumberchecked", true);
      streetnumchecked = true;
      document.querySelector("label[for='unit']").classList.remove("hidden");
    } else if ( stelements.length > 3 && validation.hasStreetNumber(stelements[0].toUpperCase()) ){
      streettip.classList.add("hidden");
      streettip.innerHTML = "";
      this.props.updateForm("streetnumberchecked", true);
      streetnumchecked = true;
      document.querySelector("label[for='unit']").classList.remove("hidden");
    } else {
      streettip.classList.remove("hidden");
      streettip.innerHTML = "Please enter your street number";
      this.props.updateForm("streetnumberchecked", false);
      document.querySelector("label[for='unit']").classList.add("hidden");
    }

    if (street.length > 6){
      streettip.classList.add("hidden");
      streettip.innerHTML = "";
      document.querySelector("label[for='street']").classList.add("activeaddy");
      this.props.updateForm("streetchecked", true);
      if (validation.checkAll([true,streetnumchecked,this.props.citychecked,this.props.statechecked,this.props.zipchecked])){
        this.props.updateForm("alladdresschecked", true);
      }
    } else {
      this.props.updateForm("streetchecked", false);
      this.props.updateForm("alladdresschecked", false);
    }
  }
  handleStreetBlur(e) {
    let streettip = document.getElementById("streettip");

    if (e.target.value.length <= 3){
      if (e.target.value.length === 0){
        e.target.classList.remove('filled');
      }
      streettip.classList.remove("hidden");
      streettip.innerHTML = "Please enter your street";
      document.querySelector("label[for='street']").classList.remove("activeaddy");
    }
  }

  handleStreetFocus(e) {
    e.target.classList.add('filled');
  }
  handleUnitChange(e) {
    this.props.updateForm("unit", e.target.value);
  }
  handleUnitBlur(e) {
    if (e.target.value.length === 0){
      e.target.classList.remove('filled');
    }
  }
  handleUnitFocus(e) {
    e.target.classList.add('filled');
  }
  handleCityChange(e) {
    let city = e.target.value;
    this.props.updateForm("city", city);

    let newaddress = this.props.street+", "+city+", "+this.props.stt+", "+this.props.zip;
    this.props.updateForm("address", newaddress);

    let citytip = document.getElementById("citytip");
    if (city.length > 2){
      citytip.classList.add("hidden");
      citytip.innerHTML = "";
      document.querySelector("label[for='city']").classList.add("activeaddy");
      this.props.updateForm("citychecked", true);
      if (validation.checkAll([true,this.props.streetnumberchecked,this.props.streetchecked,this.props.statechecked,this.props.zipchecked])){
        this.props.updateForm("alladdresschecked", true);
      }
    } else {
      this.props.updateForm("citychecked", false);
      this.props.updateForm("alladdresschecked", false);
    }
  }
  handleCityBlur(e) {
    let citytip = document.getElementById("citytip");
    if (e.target.value.length < 3){
      if (e.target.value.length === 0){
        e.target.classList.remove('filled');
      }
      citytip.classList.remove("hidden");
      citytip.innerHTML = "Please enter your city";
      document.querySelector("label[for='city']").classList.remove("activeaddy");
    }
  }
  handleCityFocus(e) {
    e.target.classList.add('filled');
  }
  handleZipChange(e) {
    let zip = e.target.value.replace(/\D/g, '');
    this.props.updateForm("zip", zip);

    let newaddress = this.props.street+", "+this.props.city+", "+this.props.stt+", "+zip;
    this.props.updateForm("address", newaddress);

    let ziptip = document.getElementById("ziptip");
    //TODO: Check if it is a valid zip code from list of all zips / change state based on zip?
    if (zip.length > 4){
      ziptip.classList.add("hidden");
      ziptip.innerHTML = "";
      document.querySelector("label[for='zip']").classList.add("activeaddy");
      this.props.updateForm("zipchecked", true);
      if (validation.checkAll([true,this.props.streetnumberchecked,this.props.streetchecked,this.props.citychecked,this.props.statechecked])){
        this.props.updateForm("alladdresschecked", true);
      }
    } else {
      this.props.updateForm("zipchecked", false);
      this.props.updateForm("alladdresschecked", false);
    }

  }
  handleZipBlur(e) {
    let ziptip = document.getElementById("ziptip");
    if ( e.target.value.length < 5){
      if (e.target.value.length === 0){
        e.target.classList.remove('filled');
      }
      ziptip.classList.remove("hidden");
      ziptip.innerHTML = "Please enter your zip code";
      document.querySelector("label[for='zip']").classList.remove("activeaddy");
    }
  }
  handleZipFocus(e) {
    e.target.classList.add('filled');
  }
  handleChange = (address) => {
    this.props.updateForm("address", address);
  }

  handleSelect = (address) => {
    this.props.updateForm("address", address);

    geocodeByAddress(address)
      .then(results => {
        let arr = results[0].address_components;
        let arrlen = arr.length;
        let countrypos = parseInt(arrlen, 10) - 3;
        if (arr[countrypos].short_name === "US" || arr[countrypos+1].short_name === "US" || arr[countrypos+2].short_name === "US"){
          if (arr[countrypos+1].short_name === "US"){
            countrypos = countrypos + 1;
          }

          let ziptip = document.getElementById("ziptip");
          if (arr[arrlen-1].short_name === "US"){
            this.props.updateForm("zipchecked", false);
            this.props.updateForm("zip", "");
            document.querySelector("label[for='zip']").classList.remove("activeaddy");
            document.getElementById("zip").classList.remove("filled");

            ziptip.classList.remove("hidden");
            ziptip.innerHTML = "Please enter your zip code";
            countrypos = countrypos + 2;
            document.getElementById("notstreet").classList.remove("hidden");
          } else {
            ziptip.classList.add("hidden");
            ziptip.innerHTML = "";
            this.props.updateForm("zipchecked", true);
            this.props.updateForm("zip", arr[countrypos+1].long_name);
            document.querySelector("label[for='zip']").classList.add("activeaddy");
            document.getElementById("zip").classList.add("filled");
            document.getElementById("notstreet").classList.add("hidden");
          }

          let street = arr[0].long_name;
          let streettip = document.getElementById("streettip");
          if (arr[0].types.includes("street_number")){
            street = street + " " + arr[1].short_name;
            this.props.updateForm("streetnumberchecked", true);
            streettip.classList.add("hidden");
            streettip.innerHTML = "";
            document.querySelector("label[for='street']").classList.add("activeaddy");
            document.getElementById("street").classList.add("filled");
            document.querySelector("label[for='unit']").classList.remove("hidden");
            document.getElementById("notstreet").classList.add("hidden");
          } else {
            this.props.updateForm("streetnumberchecked", false);
            streettip.classList.remove("hidden");
            document.querySelector("label[for='street']").classList.remove("activeaddy");
            streettip.innerHTML = "Please enter your street number";
            document.querySelector("label[for='unit']").classList.add("hidden");
            document.getElementById("notstreet").classList.remove("hidden");
          }
          this.props.updateForm("streetchecked", true);
          this.props.updateForm("street", street);
          //assign state
          this.tempstt = arr[countrypos-1].short_name.toUpperCase();
          this.tempst = arr[countrypos-1].long_name;
          this.props.updateForm("statechecked", true);

          //account for city variances
          this.props.updateForm("citychecked", true);
          document.getElementById("city").classList.add("filled");
          if (arr[countrypos-3].types.includes("locality")){
            this.props.updateForm("city", arr[countrypos-3].long_name);
          } else if (arr[countrypos-4].types.includes("locality")){
            this.props.updateForm("city", arr[countrypos-4].long_name);
          } else if (arr[countrypos-2].types.includes("locality")){
            this.props.updateForm("city", arr[countrypos-2].long_name);
          } else if (arr[countrypos-5].types.includes("locality")){
            this.props.updateForm("city", arr[countrypos-5].long_name);
          } else {
            if (arr[countrypos-3].types.includes("sublocality")){
              this.props.updateForm("city", arr[countrypos-3].long_name);
            } else if (arr[countrypos-4].types.includes("sublocality")){
              this.props.updateForm("city", arr[countrypos-4].long_name);
            } else if (arr[countrypos-2].types.includes("sublocality")){
              this.props.updateForm("city", arr[countrypos-2].long_name);
            } else if (arr[countrypos-5].types.includes("sublocality")){
              this.props.updateForm("city", arr[countrypos-5].long_name);
            } else{
              document.getElementById("city").classList.remove("filled");
              this.props.updateForm("citychecked", false);
            }
          }
          if (validation.checkAll([true,this.props.streetnumberchecked,this.props.citychecked,this.props.zipchecked])){
            this.props.updateForm("alladdresschecked", true);
          }
        } else {
          document.getElementById("selectedAddress").classList.add("hidden");
          this.props.updateForm("address", "");
          this.props.updateForm("street", "");
          this.props.updateForm("city", "");
          this.props.updateForm("zip", "");
          this.props.updateForm("streetchecked", false);
          this.props.updateForm("citychecked", false);
          this.props.updateForm("statechecked", false);
          this.props.updateForm("zipchecked", false);
          this.props.updateForm("alladdresschecked", false);
          this.props.updateForm("addresschecked", false);
        }
        // eslint-disable-next-line
        if (this.props.stt && this.props.stt.toUpperCase() == this.tempstt){
          document.getElementById("selectedAddress").classList.remove("hidden");
          this.props.updateForm("stt", this.tempstt);
          this.props.updateForm("st", this.tempst);
          document.getElementById("state-placeholder").classList.add('state-label');
          document.querySelector("label[for='st']").classList.add("active");
          this.props.updateForm("addresschecked", true);
        } else {
          //show are you sure?
          document.getElementById("areyousure").classList.remove("hidden");
          document.getElementById("selectedAddress").classList.add("hidden");
          this.props.updateForm("addresschecked", false);

        }
      })
      .catch(error => console.error('Error', error));
  }

  handleStateConfirm(e) {
    e.preventDefault();

    [].forEach.call( document.querySelectorAll('.changestbtn'), function(el) {
      el.classList.remove("activated");
    });
    e.target.classList.add("activated");

    const sliderdiv = document.getElementById("loanslider");

    if (e.target.dataset.answer === "Yes"){
      this.props.updateForm("addresschecked", true);

      this.props.updateForm("statechanged", true);

      this.props.updateForm("st", this.tempst);
      this.props.updateForm("stt", this.tempstt);
      document.getElementById("state-placeholder").classList.add('state-label');
      document.querySelector("label[for='st']").classList.add("active");
      //reset states
      this.props.updateForm("notserved", false);
      this.props.updateForm("stateserved", false);
      // check if a match of states we serve
      if (statesserved.indexOf(this.tempstt) >= 0){
        this.props.updateForm("stateserved", true);
        //check the min and max amounts
        let min = 200;
        let max = 1000;

        // eslint-disable-next-line
        if (this.tempstt == "CA"){
          min = 255;
          max = 255;
        // eslint-disable-next-line
        }else if (this.tempstt == "AL"){
          min = 2000;
          max = 2600;
        // eslint-disable-next-line
        }else if(this.tempstt == "MO"){
          min = 500;
          max = 1000;
        // eslint-disable-next-line
        }else if(this.tempstt == "OH"){
          min = 150;
          max = 1500;
        // eslint-disable-next-line
        }else if(this.tempstt == "MS"){
          min = 550;
          max = 1475;
        // eslint-disable-next-line
        } else if(this.tempstt == "NM"){
          min = 200;
          max = 1400;
        // eslint-disable-next-line
        } else if((this.tempstt == "DE") || (this.tempstt == "UT")){
          min = 150;
          max = 1000;
        // eslint-disable-next-line
        } else if(this.tempstt == "TX"){
          min = 150;
          max = 500;
        // eslint-disable-next-line
        } else if(this.tempstt == "WI"){
          min = 150;
          max = 700;
        // eslint-disable-next-line
        } else if(this.tempstt == "TN"){
          min = 200;
          max = 1475;
        }
        // calc the middle amount between min and max loan amounts
        let diff =  max - ((max - min) / 2);
        //round amount to nearest hundred
        let newamt = Math.round(diff/100) * 100;
        if (min === max) newamt = max;

        this.props.updateForm("minamt", min);
        this.props.updateForm("maxamt", max);
        this.props.updateForm("loanamt", newamt);
        this.props.updateForm("askedforamt", newamt);

        // eslint-disable-next-line
        if (this.tempstt != "AL" || this.tempstt != "MS"){
          this.props.updateForm("legalage", 18);
        } else {
          // eslint-disable-next-line
          if (this.tempstt == "AL")
            this.props.updateForm("legalage", 19);
          else
            this.props.updateForm("legalage", 21);
        }

        // eslint-disable-next-line
        if (this.tempstt != "TN" || this.tempstt != "KS" || this.tempstt != "DE" || this.tempstt != "CA"){
          this.props.updateForm("loantype", "Installment Loan");
        // eslint-disable-next-line
        } else if (this.tempstt == "CA") {
          this.props.updateForm("loantype", "Payday Loan");
        } else {
          this.props.updateForm("loantype", "Line of Credit");
        }

        // eslint-disable-next-line
        if (this.tempstt != "CA"){
          sliderdiv.classList.remove("hidden");
          scroll.scrollTo(300, {duration: 1000});
          setTimeout(()=>{document.querySelector('.rangeslider__handle').focus()},10);
        } else {
          sliderdiv.classList.add("hidden");
        }
      } else {
        this.props.updateForm("notserved", true);
        sliderdiv.classList.add("hidden");
      }
      document.getElementById("selectedAddress").classList.remove("hidden");
    } else {
      document.getElementById("selectedAddress").classList.add("hidden");
      this.props.updateForm("address", "");
      this.props.updateForm("street", "");
      this.props.updateForm("city", "");
      this.props.updateForm("zip", "");
      this.props.updateForm("streetnumberchecked", false);
      this.props.updateForm("streetchecked", false);
      this.props.updateForm("citychecked", false);
      this.props.updateForm("statechecked", false);
      this.props.updateForm("zipchecked", false);
      this.props.updateForm("alladdresschecked", false);
      this.props.updateForm("addresschecked", false);

      sliderdiv.classList.add("hidden");
    }
    document.getElementById("areyousure").classList.add("hidden");
  }

  render() {

    const nextInfo = 1;
    const nextLink = "/livingsituation";
    const btnText = "Continue";
    const btnClasses = "btn next-step";

    let searchOptions = {
      types: ['address'],
      componentRestrictions: {country: "us"}
    }

    return (
        <AccountLayout>
            <div className="container" id="stepper-step-3">
                <div className="text-center topcopy">
                    <h1>What&#39;s your address?</h1>
                    <img src="/images/svg/addressicon.svg" className="style-svg" alt="" />
                </div>
                <hr />
                <form className="flowform">
                    <div className="form-group">
                        <div className="errortip hidden" id="addytip">
                            Please provide an address.
                        </div>
                        <PlacesAutocomplete
                          value={this.props.address}
                          onChange={this.handleChange}
                          onSelect={this.handleSelect}
                          searchOptions={searchOptions}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                              <div>
                                <input
                                  {...getInputProps({
                                    placeholder: 'Start typing street.. (ie: 28 Main St)',
                                    className: 'location-search-input',
                                    id: 'addressinput'
                                  })}
                                />
                                <div className="autocomplete-dropdown-container">
                                  {suggestions.map(suggestion => {
                                    const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                                    // inline style for demonstration purpose
                                    const style = suggestion.active
                                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                    return (
                                      <div {...getSuggestionItemProps(suggestion, { className, style })}>
                                        <span>{suggestion.description}</span>
                                      </div>
                                    )
                                  })}
                                </div>
                              </div>
                            )}
                        </PlacesAutocomplete>
                    </div>
                    <div id="areyousure" className="nopadbuttons text-center hidden">
                        <h3>Change your state of residence from {this.props.stt} to {this.tempstt}?</h3>
                        <div className="button-group">
                          <a className="btn yesno changestbtn" data-answer="No" onClick={this.handleStateConfirm} tabIndex="1">No</a>
                          <a className="btn yesno changestbtn" data-answer="Yes" onClick={this.handleStateConfirm} tabIndex="2">Yes</a>
                        </div>
                    </div>
                    <div id="notstreet" className="text-center hidden">
                        <p >Hmmm... looks like something isn&#39;t right. Let&#39;s make sure we have the right information. Please enter your address below.</p>
                    </div>
                    <div id="selectedAddress" className="form-group">
                        <div className="errortip hidden" id="streettip">
                            Please provide your street address.
                        </div>
                        <label htmlFor="street" className="activeaddy">
                          <input type="text" name="street" id="street" className="form-control filled" value={this.props.street} onChange={this.handleStreetChange} onBlur={this.handleStreetBlur} onFocus={this.handleStreetFocus} tabIndex="3"/>
                          <span className="floating-label">Street Address</span>
                        </label>
                        <label htmlFor="unit" className="ptop hidden">
                          <input type="text" name="unit" id="unit" className="form-control" value={this.props.unit} onChange={this.handleUnitChange} onBlur={this.handleUnitBlur} onFocus={this.handleUnitFocus} tabIndex="4" />
                          <span className="floating-label">Unit/Apartment number</span>
                        </label>
                        <div className="errortip hidden" id="citytip">
                            Please provide your city.
                        </div>
                        <label htmlFor="city" className="activeaddy ptop">
                          <input type="text" name="city" id="city" className="form-control filled" value={this.props.city} onChange={this.handleCityChange} onBlur={this.handleCityBlur} onFocus={this.handleCityFocus} tabIndex="5"/>
                          <span className="floating-label">City</span>
                        </label>
                        <div className="errortip hidden" id="sttip">
                            Please provide your state.
                        </div>
                        <label htmlFor="st" className="activeaddy ptop">
                          <StateSelector2 />
                          <span id="state-placeholder" className="state-label floating-label">State</span>
                        </label>
                        <div className="errortip hidden" id="ziptip">
                            Please provide your zip code.
                        </div>
                        <label htmlFor="zip" className="activeaddy ptop">
                          <input type="text" name="zip" id="zip" className="form-control filled" value={this.props.zip} onChange={this.handleZipChange} onBlur={this.handleZipBlur} onFocus={this.handleZipFocus} maxLength="5" tabIndex="7" />
                          <span className="floating-label">Zip Code</span>
                        </label>

                        <div id="loanslider" className="hidden form-group padtop30">
                          <LoanSlider />
                        </div>
                    </div>

                    <NextInfoButton next={nextLink} btnText={btnText} btnClasses={btnClasses} disableNext={!this.props.alladdresschecked} hideNext={!this.props.addresschecked} infostep={nextInfo} tabIndex="9"/>

                </form>
            </div>
        </AccountLayout>
    );
  }
}

const mapStateToProps = (state) => ({
    loanamt: state.FormReducer.loanamt,
    askedforamt: state.FormReducer.askedforamt,
    address: state.FormReducer.address,
    street: state.FormReducer.street,
    unit: state.FormReducer.unit,
    city: state.FormReducer.city,
    st: state.FormReducer.st,
    stt: state.FormReducer.stt,
    zip: state.FormReducer.zip,
    addresschecked: state.FormReducer.addresschecked,
    streetchecked: state.FormReducer.streetchecked,
    streetnumberchecked: state.FormReducer.streetnumberchecked,
    citychecked: state.FormReducer.citychecked,
    statechecked: state.FormReducer.statechecked,
    statechanged: state.FormReducer.statechanged,
    zipchecked: state.FormReducer.zipchecked,
    alladdresschecked: state.FormReducer.alladdresschecked,
    lateststep: state.FormReducer.lateststep,
    currentstep: state.FormReducer.currentstep
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step)),
    setInfo: (infostep) => dispatch(setInfo(infostep)),
    setLatest: (lateststep) => dispatch(setLatest(lateststep)),
    setCurrent: (currentstep) => dispatch(setCurrent(currentstep)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddressInfo)



// WEBPACK FOOTER //
// ./src/components/views/AddressInfo/index.js